import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { Label } from 'components/Form/Label/Label';
import React from 'react';
import classes from './WaitlistPickerField.module.scss';

interface WaitlistPickerFieldProps {
    label: string;
    value?: string;
    placeholder: string;
    open?: boolean;
    onClick: () => void;
}

/**
 * Compact "label + value + chevron" trigger used next to the waitlist selects to
 * open the date / hour pickers.
 */
export const WaitlistPickerField = React.forwardRef<HTMLButtonElement, WaitlistPickerFieldProps>(
    ({ label, value, placeholder, open = false, onClick }, ref) => {
        return (
            <div className={classes.root}>
                <Label className={classes.label}>{label}</Label>

                <button
                    ref={ref}
                    type="button"
                    aria-haspopup="true"
                    aria-expanded={open}
                    className={classes.trigger}
                    onClick={onClick}
                >
                    <span className={clsx(classes.value, { [classes.placeholder]: !value })}>
                        {value ?? placeholder}
                    </span>

                    <span className={classes.chevron}>
                        <FontAwesomeIcon icon={faAngleDown} />
                    </span>
                </button>
            </div>
        );
    }
);

WaitlistPickerField.displayName = 'WaitlistPickerField';
